import * as Sentry from '@sentry/react';
import { env } from '../env';

export function initSentry() {
  const dsn = window.location.pathname.startsWith('/admin') ? env.sentryAdminDsn : env.sentryWebDsn;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2
  });
}

